<template>
    <div class="q-px-md">
        <q-toolbar class="text-white shadow-2" style="background:rgb(39 170 225);">
            <q-toolbar-title>Grow Together: Unlock Better Features with Every Donation!</q-toolbar-title>
        </q-toolbar>
        <q-list class="q-px-md" bordered>
            <q-item clickable>
                <q-item-section>
                    <q-item-label>
                        Memo.Link thrives on generosity!
                        The more donations we receive, the more powerful features we can support free—for everyone.
                        Together, your contributions improve the experience for the entire community!
                    </q-item-label>
                </q-item-section>
            </q-item>
            <q-item clickable>
                <q-item-section>
                    <q-item-label>
                        <a href="https://app.ens.domains/memolink.eth" target="_blank">memolink.eth</a> = <b>[0x6Eff...2F85]</b><br/>
                        <a href="https://www.sns.id/domain/memolink" target="_blank">memolink.sol</a> = <b>[5qMi...oTLr]</b>
                    </q-item-label>
                </q-item-section>
            </q-item>
            <q-item clickable>
                <q-item-section>
                    <q-item-label>
                        <q-linear-progress stripe rounded size="20px" :value="milestoneProgress" color="green"
                                           class="q-my-sm">
                            <div class="absolute-full flex flex-center">
                                <q-badge color="white" text-color="accent" :label="`${milestoneProgress*100}%`"/>
                            </div>
                        </q-linear-progress>
                    </q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
        <q-expansion-item
            label="Roadmap"
            header-class="text-white"
            style="background:rgb(39 170 225);"
            expand-icon-class="text-white">
            <q-markup-table>
                <thead>
                <tr>
                    <th class="text-left"></th>
                    <th class="text-center">Unlocked Feature for ALL Users</th>
                    <th class="text-left">Milestone progress</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td class="text-left">Milestone 14</td>
                    <td class="text-center">Custom domain minimum length: 1 character</td>
                    <td class="text-left">0%</td>
                </tr>
                <tr>
                    <td class="text-left">Milestone 13</td>
                    <td class="text-center">Number of custom domains: 5</td>
                    <td class="text-left">0%</td>
                </tr>
                <tr>
                    <td class="text-left">Milestone 12</td>
                    <td class="text-center">Custom domain minimum length: 2 characters</td>
                    <td class="text-left">0%</td>
                </tr>
                <tr>
                    <td class="text-left">Milestone 11</td>
                    <td class="text-center">Memo Link expiration: never</td>
                    <td class="text-left">0%</td>
                </tr>
                <tr>
                    <td class="text-left">Milestone 10</td>
                    <td class="text-center">Custom domain minimum length: 3 characters</td>
                    <td class="text-left">0%</td>
                </tr>
                <tr>
                    <td class="text-left">Milestone 9</td>
                    <td class="text-center">Number of custom domains: 3</td>
                    <td class="text-left">72%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 8</td>
                    <td class="text-center">Memo Link expiration: 1 year</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 7</td>
                    <td class="text-center">Minimum Number of Tags: 1</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 6</td>
                    <td class="text-center">Memo Link expiration: 2 months</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 5</td>
                    <td class="text-center">Minimum Number of Tags: 2</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 4</td>
                    <td class="text-center">Memo Link expiration: 1 week</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 3</td>
                    <td class="text-center">Minimum Number of Tags: 3</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 2</td>
                    <td class="text-center">Custom domain minimum length: 4 characters</td>
                    <td class="text-left">100%</td>
                </tr>
                <tr class="milestone-completed">
                    <td class="text-left">Milestone 1</td>
                    <td class="text-center">Number of custom domains: 1</td>
                    <td class="text-left">100%</td>
                </tr>
                </tbody>
            </q-markup-table>
        </q-expansion-item>
    </div>
</template>

<script setup>
import { inject, ref } from 'vue'

const milestoneProgress = ref(parseInt(inject('milestoneProgress')) / 100)
</script>

<style scoped>
table.q-table th {
    font-weight: bold;
    font-size: 1rem
}

table.q-table tr.milestone-completed {
    background: var(--q-positive);
    color: #fffe
}
.q-toolbar__title {
    font-size: 14px;
    text-wrap: unset;
}
</style>
